/** @format */

const noContentMessage =
  "We're sorry, this page is unavailable. Try heading back to the home page.";
const noContentMessagePL =
  "We're sorry, this page is unavailable. Let's get you back on the trail.";
const linkTextContent = 'GO BACK HOME';

export const noContentErrorMessages = {
  gg: {
    title: '4-0-Fore!',
    message: noContentMessage,
    link: 'https://www.golfgalaxy.com',
    linkText: linkTextContent,
  },
  pl: {
    title: "You're off the map",
    message: noContentMessagePL,
    link: 'https://www.publiclands.com',
    linkText: linkTextContent,
  },
  plf: {
    title: "You're off the map",
    message: noContentMessagePL,
    link: 'https://www.publiclandsfund.org',
    linkText: linkTextContent,
  },
  dsg: {
    title: 'Error on the play',
    message: noContentMessage,
    link: 'https://www.dickssportinggoods.com',
    linkText: linkTextContent,
  },
  sm: {
    title: 'Error on the play',
    message: noContentMessage,
    link: 'https://www.sportsmatter.org',
    linkText: linkTextContent,
  },
  g3: {
    title: 'No Scores Here',
    message: noContentMessage,
    link: 'https://www.goinggoinggone.com',
    linkText: linkTextContent,
  },
};
